import { proxy } from "valtio";

export const masterjobStore = proxy({
    current:{},
    bookingData:[],
    linkedBookingData:[],
    disable:false,
    edit:false,
    linkedBookings:false,
    bookingListId:[]
})

export const resetMasterJobStore = () => {
  masterjobStore.current = {};
  masterjobStore.bookingData = [];
  masterjobStore.linkedBookingData = [];
  masterjobStore.disable = false;
  masterjobStore.edit = false;
  masterjobStore.linkedBookings = false;
  masterjobStore.bookingListId = [];
};